import DoneIcon from '@mui/icons-material/Done';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { InputAdornment, OutlinedInput, TextField } from "@mui/material";
import _ from "lodash";
import React, { useCallback, useState } from "react";
import { inputChange, onModelChange } from './util';

function InlineEditableField(props) {
	const { model, field, service, mutator, component: Component = OutlinedInput } = props;
	const [changed, setChanged] = useState(0);
	const [saved, setSaved] = useState(false);

	const onChange = (e, model, field) => {console.log('chanign');
		setChanged(new Date().getTime());
		if (saved) {
			clearTimeout(saved);
		}

		model = onModelChange(model, e, field);
		debouncePatch(model, field);
	}

	const patch = useCallback(async (model, field) => {
		const before = changed;
		
		const result = await mutator.mutateAsync(model.id ? {..._.pick(model, ['id', field])} : model);
		if (before == changed) {
			setChanged(0);
		}

		setSaved(setTimeout(() => {
			setSaved(false);
		}, 3000));
	}, []);

	const debouncePatch = useCallback(
		_.debounce((model, field) => patch(model, field), 750),
	   [patch]
	);

	const keyDown = (e) => {
		try{
			if(e.key == 'ArrowDown' || e.key == 'ArrowUp'){
				const delta = e.key == 'ArrowDown' ? 1 : -1;

				const currentTd = e.currentTarget.closest('td');
				const colIndex = Array.from(currentTd.parentNode.children).indexOf(currentTd);

				const rows = Array.from(document.querySelectorAll('tr'));
				const currentRow = currentTd.parentNode;
				const rowIndex = rows.indexOf(currentRow);

				const nextRow = rows[rowIndex + delta];
				const nextCell = nextRow?.children[colIndex];
				const input = nextCell?.querySelector('.inline-editable');
				input?.focus();
				e.preventDefault();
			}
			else if(e.key == 'ArrowLeft' || e.key == 'ArrowRight'){
				let delta = 0;
				const start = e.currentTarget.selectionStart;
				const end = e.currentTarget.selectionEnd;
				const length = e.currentTarget.value?.length ?? 0;
				
				if( e.key == 'ArrowLeft' && start == 0 && end == 0 ){
					delta = -1;
				}
				else if( e.key == 'ArrowRight' && start == length && end == length ){
					delta = 1;
				}
				if( !delta ){
					return;
				}

				const row = e.currentTarget.closest('tr');
				const siblings = row.querySelectorAll('.inline-editable');
				const index = _.findIndex(siblings, e.currentTarget);
				siblings[index + delta]?.focus();
				e.preventDefault();
			}
		}
		catch(e){}
	}

	const paste = (e) => {
		const content = e.clipboardData.getData('text');
		const lines = content.split(/\r?\n/);

		if (lines.length <= 1){
			return;
		}

		e.preventDefault();

		const currentTd = e.currentTarget.closest('td');
		const colIndex = Array.from(currentTd.parentNode.children).indexOf(currentTd);

		const rows = Array.from(document.querySelectorAll('tr'));
		const currentRow = currentTd.parentNode;
		const rowIndex = rows.indexOf(currentRow);

		//check to make sure rows exist first

		for( let i = 0; i < lines.length; i++ ){
			const line = lines[i];
			const tabs = line.split(/\t/);
			for( let j = 0; j < tabs.length; j++ ){
				const tab = tabs[j];
				const row = rows[rowIndex + i];
				const cell = row?.children[colIndex + j];
				const input = cell?.querySelector('.inline-editable');
				inputChange(input, tab);
			}
		}
	};

	if( Component.render?.name == 'TextField' ){
		return (
			<Component
				{...props?.slots?.input}
				InputProps={{ endAdornment:(<InputAdornment position="end">{changed ? <PriorityHighIcon /> : <DoneIcon sx={{ visibility: saved ? 'visible' : 'hidden' }} />}</InputAdornment>) }}
				defaultValue={model[field]}
				fullWidth
				onKeyDown={keyDown}
				onPaste={paste}
				onChange={(e) => onChange(e, model, field)}
			/>
		);
	}
	else{
		return (
			<Component
				{...props?.slots?.input}
				inputProps={{ className:'inline-editable' }}
				defaultValue={model[field]}
				fullWidth
				onKeyDown={keyDown}
				onPaste={paste}
				onChange={(e) => onChange(e, model, field)}
				endAdornment={<InputAdornment position="end">{changed ? <PriorityHighIcon /> : <DoneIcon sx={{ visibility: saved ? 'visible' : 'hidden' }} />}</InputAdornment>}
			/>
		);
	}
}

export default React.memo(InlineEditableField);